import { asCardMutations, type CardsMutationHandler } from '@atlassian/jira-software-ec-client';

import type { State, Action, MiddlewareAPI, Dispatch, BoardDependencies } from '../../types';

const processAction =
	(cardsMutationHandler: CardsMutationHandler) =>
	(preState: State, state: State, action: Action): void => {
		const cardsMutations = asCardMutations(action);
		if (cardsMutations) {
			cardsMutationHandler(cardsMutations);
		}
	};

export const ecClientMiddleware =
	(dependencies: BoardDependencies) =>
	(store: MiddlewareAPI) =>
	(next: Dispatch) =>
	(action: Action): Action => {
		const preState = store.getState();
		next(action);
		const state = store.getState();
		if (dependencies.isCMPBoard && dependencies.onCardsChange) {
			processAction(dependencies.onCardsChange)(preState, state, action);
		}
		return action;
	};
